import { Component, OnInit } from '@angular/core';
import { AccountService } from 'src/app/services/account.service';

@Component({

  selector: 'app-footer',

  templateUrl: './footer.component.html',

  styleUrls: ['./footer.component.css']

})

export class FooterComponent implements OnInit {

  version: string = `${(<any>window).version}`;

  obj_Social: { strTM: string, strWA: string, strIG: string, strEmail: string } | any = {};

  constructor() { }

  ngOnInit(): void {
    this.obj_Social.strIG = 'taxilon24';
    this.obj_Social.strEmail = 'info@emdadran.com';
  }

}
